import { render, staticRenderFns } from "./GroupPage.vue?vue&type=template&id=572fd773&scoped=true&"
import script from "./GroupPage.vue?vue&type=script&lang=js&"
export * from "./GroupPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupPage.vue?vue&type=style&index=0&id=572fd773&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572fd773",
  null
  
)

export default component.exports